<template>
  <v-dialog
    v-model="confirmationDialog"
    persistent
    max-width="450"
  >
    <v-card>
      <v-card-title class="headline">{{title}}</v-card-title>
      <v-card-text>
        {{message}}
      </v-card-text>
      <v-text-field
          v-if="inputRequired"
          v-model="inputValue"
          label="Digite um nome"
          filled
          hide-details
          dense
          class="dense-padding-input-slot"
        />
      <v-card-actions>
        <v-btn color="secondary" text @click="cancel()">{{ cancelButton }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click.stop="confirm()">{{ confirmButton }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'confirm-dialog',
  props: ['title', 'message', 'cancelButton', 'confirmButton', 'confirmationDialog', 'inputRequired'],
  data () {
    return {
      inputValue: ''
    }
  },
  methods: {
    confirm () {
      if (this.inputRequired) {
        this.$emit('confirm', this.inputValue)
        this.inputValue = ''
      } else {
        this.$emit('confirm')
      }
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>
